// assets/js/key-topics.js
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const isEditor = document.body.classList.contains("wp-admin");
if (!isEditor) gsap.registerPlugin(ScrollTrigger);

function initKeyTopics(section) {
  if (!section || section.__ktInit) return;
  section.__ktInit = true;

  const eyebrow = section.querySelector(".key-topics__eyebrow");
  const headline = section.querySelector(".key-topics__headline");
  const intro = section.querySelector(".key-topics__top-right");
  const cards = section.querySelectorAll(".key-topics__card");

  gsap.set([eyebrow, headline, intro], { opacity: 0, y: 18 });
  if (cards.length) gsap.set(cards, { opacity: 0, y: 14 });

  const tlOpts = isEditor
    ? { defaults: { ease: "power3.out" } }
    : {
        defaults: { ease: "power3.out" },
        scrollTrigger: {
          trigger: section,
          start: "top 78%",
          once: true,
        },
      };

  const tl = gsap.timeline(tlOpts);

  if (eyebrow) tl.to(eyebrow, { opacity: 1, y: 0, duration: 0.45 });
  if (headline) tl.to(headline, { opacity: 1, y: 0, duration: 0.7 }, "-=0.2");
  if (intro) tl.to(intro, { opacity: 1, y: 0, duration: 0.55 }, "-=0.35");

  if (cards.length) {
    tl.to(cards, { opacity: 1, y: 0, duration: 0.5, stagger: 0.08 }, "-=0.25");
  }
}

const mount = () => {
  if (!isEditor) {
    document.querySelectorAll(".key-topics").forEach(initKeyTopics);
    return;
  }

  const root = document.querySelector(".editor-styles-wrapper") || document;
  const run = () => root.querySelectorAll(".key-topics").forEach(initKeyTopics);

  run();

  const mo = new MutationObserver(run);
  mo.observe(root, { childList: true, subtree: true });
};

if (window.wp?.domReady) window.wp.domReady(mount);
else document.addEventListener("DOMContentLoaded", mount);
